import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/pdpBundling/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showPdpBundlingSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showPdpBundlingSelector };
